<template>
    <RPDashboardLayout
        :sections="sections.sections"
        :active-section="sections.activeSection"
        :subsections="sections.subsections"
        :active-subsection="sections.activeSubsection"
        class="ModalDemo"
    >
        <RPModal status="saving" />
    </RPDashboardLayout>
</template>
<script>
import RPModal from 'components/Complex/Modal/RPModal.vue';
import RPDashboardLayout from 'components/Layouts/Common/RPDashboardLayout.vue';
export default {
    name: 'ModalDemo',
    components: {
        RPModal,
        RPDashboardLayout
    },
    data(){
        return {
            sections: {"sections": [{"key": "dashboard","label": "Dashboard","icon": "home","to": {"name": "Dashboard"}},{"key": "locations","label": "Locations","icon": "locations","to": {"name": "CompanyLocationsTable"}},{"key": "measure","label": "Measure","icon": "measure","to": {"name": "OverviewReport"}},{"key": "request","label": "Request","icon": "request","to": {"name": "CampaignsTable"}},{"key": "respond","label": "Respond","icon": "respond","to": {"name": "ResponseFeed"}},{"key": "settings","label": "Settings","icon": "settings","to": {"name": "UserNotificationsSettings"}}],"activeSection": {"key": "settings","label": "Settings","icon": "settings","to": {"name": "UserNotificationsSettings"}},"subsections": [{"label": "User Settings","key": "user","to": {"name": "UserNotificationsSettings"}},{"label": "Global Settings","key": "global","to": {"name": "GlobalNotifications"}}],"activeSubsection": {"label": "Global Settings","key": "global","to": {"name": "GlobalNotifications"}}}
        };
    }
};
</script>
<style lang="scss">
    .ModalDemo {
    }
</style>
